import GenTempImageView from './GenTempImageView';

export default GenTempImageView;
